import { LayoutService } from '../../layout/layout.service';
import { MobileDetectorService } from '../mobile-detector.service';
import { OnDestroy } from '@angular/core';

export abstract class HeadlessView implements OnDestroy {

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
    ) {
        this.manageHeader();
    }

    public manageHeader() {
        this.mobileDetectorService.initScreenSizeWatcher();
        if (this.mobileDetectorService.isMobile()) {
            this.layoutService.disableHeader();
        }
        this.mobileDetectorService.breakpointCheck.subscribe(data => {
            if (data.mobile) {
                this.layoutService.disableHeader();
            } else {
                this.layoutService.enableHeader();
            }
        });
    }

    ngOnDestroy() {
        this.layoutService.enableHeader();
    }
}
